import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import MapPage from "@/pages/MapPage";
import Research from "@/pages/Research";
import ArticleDetail from "@/pages/ArticleDetail";
import Videos from "@/pages/Videos";
import Connect from "@/pages/Connect";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import SiteGate, { SiteSettingsProvider } from "@/components/SiteGate";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<SiteGate><Home /></SiteGate>} />
      <Route path="/map" element={<SiteGate><MapPage /></SiteGate>} />
      <Route path="/research" element={<SiteGate><Research /></SiteGate>} />
      <Route path="/research/:slug" element={<SiteGate><ArticleDetail /></SiteGate>} />
      <Route path="/videos" element={<SiteGate><Videos /></SiteGate>} />
      <Route path="/connect" element={<SiteGate><Connect /></SiteGate>} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SiteSettingsProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </SiteSettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
